import React, { Component } from "react";

import PaginationV2 from "@app/components/Pagination/V2";

import * as Constant from "@app/Constant.js";

import { AgGridReact } from "ag-grid-react";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

import axios from "@app/lib/axios";

const getAgeStr = (age) => {
    if (age !== 123) {
        return `만${Number(age) + 2}세`;
    } else {
        return `혼합`;
    }
};
const getLevelStr = (level) => {
    switch(level) {
        case 0: return 'A';
        case 1: return 'B';
        case 2: return 'C';
        case 3: return 'D';
        default: return '-';
    }
};
const basePagingInfo = { perPage: 10, maxShowPage: 10 };
class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            doSomething: false,
            list: [],
            page: this.props.page || 0,
            type: this.props.type || "code",
            keyword: this.props.keyword || "",
            status: this.props.status || "",
            paging: true,
        };
    }

    componentDidMount() {
        this.getList(this.state.page);
    }

    getList = (page) => {
        this.setState(
            {
                loaded: false,
                doSomething: true,
            },
            function () {
                axios({
                    method: "get",
                    url: Constant.API_DOMAIN + `/api/tomoplay/child/list?page=${page}&type=${this.state.type}&keyword=${this.state.keyword}&status=${this.state.status}`,
                })
                    .then((result) => {
                        console.debug(result.data);
                        if (result.data.code === 200) {
                            this.setState({
                                page: page,
                                list: result.data.data.list,
                                total_cnt: result.data.data.total_cnt,
                                paging: result.data.data.paging,
                                loaded: true,
                                doSomething: false,
                            });
                        } else {
                            this.setState({
                                loaded: true,
                                doSomething: false,
                            });
                            toast.error(result.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.setState({
                            loaded: true,
                            doSomething: false,
                        });
                        console.log(error);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    });
            }
        );
    };

    handleChange = (e) => {
        const target = e.target;
        const value = target.value;
        const name = target.name;

        var stateData = {
            [name]: value,
        };

        if (name === "status") {
            stateData.page = 0;
            this.setState(stateData, this.getList(0));
        } else this.setState(stateData);
    };

    defaultColDef = {
        headerClass: "bg-dark text-light",
    };
    listColumn = [
        {
            headerName: "ID",
            field: "id",
            sortable: false,
            width: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원아명",
            field: "name",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "생일",
            field: "birth",
            sortable: false,
            width: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원명",
            field: "class.nname",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "반명",
            field: "class.cname",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "원아코드",
            field: "code",
            sortable: true,
            width: 80,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "노트",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.tomonote_approval === "AP" && param.data.age) {
                    result = getAgeStr(param.data.age);
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "momo",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.momo_approval === "AP" && param.data.age_momo) {
                    result = getAgeStr(param.data.age_momo);
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "딩동",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.playdd_approval === "AP" && param.data.age_dd) {
                    result = getAgeStr(param.data.age_dd);
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "별별",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.tomobooks_approval === "AP" && param.data.age_books) {
                    result = getAgeStr(param.data.age_books);
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "젤링",
            field: "code",
            sortable: false,
            maxWidth: 60,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.class.jelliing_approval === "AP" && param.data.age_jelliing) {
                    result = getLevelStr(param.data.age_jelliing);
                } else {
                    result = "-";
                }
                return result;
            },
        },
        {
            headerName: "계약",
            field: "code",
            sortable: false,
            minWidth: 180,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";

                if (param.data.class.tomonote_approval === "AP") {
                    result = "토모노트:계약(" + (param.data.class.age === 123 ? "혼합" : `${param.data.class.age + 2}세`) + ")";
                } else {
					result = "토모노트:계약없음";
				}
                if (param.data.class.momo_approval === "AP") {
                    result += "/momo:계약(" + (param.data.class.momo_age === 123 ? "혼합" : `${param.data.class.momo_age + 2}세`) + ")";
                } else {
					result += "/momo:계약없음";
				}
                if (param.data.class.playdd_approval === "AP") {
                    result += "/딩동:계약(" + (param.data.class.dd_age === 123 ? "혼합" : `${param.data.class.dd_age + 2}세`) + ")";
                } else {
					result += "/딩동:계약없음";
				}
                if (param.data.class.jelliing_approval === "AP") {
                    result += "/젤링:계약(" + (param.data.class.jelliing_age === 123 ? "혼합" : `${param.data.class.jelliing_age + 2}세`) + ")";
                } else {
					result += "/젤링:계약없음";
				}
                if (param.data.class.tomobooks_approval === "AP") {
                    result += "/별별책방:계약(" + (param.data.class.books_age === 123 ? "혼합" : `${param.data.class.books_age + 2}세`) + ")";
                } else {
					result += "/별별책방:계약없음";
				}
                return result;
            },
        },
        {
            headerName: "부모계정",
            field: "p_user_id",
            sortable: true,
            width: 120,
            resizable: true,
            cellClass: "text-center",
            filter: false,
        },
        {
            headerName: "상태-토모플레이",
            field: "status",
            sortable: false,
            width: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.retire_yn === "Y") {
                    result = "-";
                } else if (param.data.createDateTomoplay && !param.data.deleteDateTomoplay) {
                    if(param.data.p_user_id) {
                        if(param.data.parentStatus == 'deleted') {
                            result = "탈퇴";
                        } else if(param.data.agreeTomoplay || param.data.parentIsLegacy) {
                            result = "가입";
                        } else {
                            result = "-";
                        }
                    } else if(param.data.inviteDateTomoplay) {
                        result = "초대 O";
                    } else {
                        result = "초대 X";
                    }
                } else {
                    result = "등록 X";
                }
                return result;
            },
        },
        {
            headerName: "상태-젤링",
            field: "status",
            sortable: false,
            width: 110,
            resizable: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                let result = "";
                if (param.data.retire_yn === "Y") {
                    result = "-";
                } else if (param.data.createDateJelliing && !param.data.deleteDateJelliing) {
                    if(param.data.p_user_id) {
                        if(param.data.parentStatus == 'deleted') {
                            result = "탈퇴";
                        } else if(param.data.agreeJelliing) {
                            result = "가입";
                        } else {
                            result = "-";
                        }
                    } else if(param.data.inviteDateJelliing) {
                        result = "초대 O";
                    } else {
                        result = "초대 X";
                    }
                } else {
                    result = "등록 X";
                }
                return result;
            },
        },
        {
            headerName: "퇴소",
            field: "status",
            sortable: false,
            width: 120,
            resizable: true,
			hide: true,
            cellClass: "text-center",
            filter: false,
            cellRenderer: (param) => {
                return param.data.retire_yn === "Y" ? param.data.statusChangeDate : "-";
            },
        },
    ];

    onGridReady = (params) => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
    };

    render() {
        if (this.state.loaded) {
            return (
                <div className="card border-top">
                    <div className="card-body">
                        <div className="row" style={{ marginBottom: "20px" }}>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="" checked={this.state.status === ""} className="custom-control-input" onChange={this.handleChange} />
                                    <span className="custom-control-label">전체</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="ready" checked={this.state.status === "ready"} className="custom-control-input" onChange={this.handleChange} />
                                    <span className="custom-control-label">등록</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="invite" checked={this.state.status === "invite"} className="custom-control-input" onChange={this.handleChange} />
                                    <span className="custom-control-label">초대</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="join" checked={this.state.status === "join"} className="custom-control-input" onChange={this.handleChange} />
                                    <span className="custom-control-label">가입</span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="retire" checked={this.state.status === "retire"} className="custom-control-input" onChange={this.handleChange} />
                                    <span className="custom-control-label">퇴소</span>
                                </label>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                                <div className="input-group my-group input-group">
                                    <select
                                        name="type"
                                        className="form-control input-group-append"
                                        title="검색 항목 선택"
                                        value={this.state.type}
                                        style={{ height: "auto", maxWidth: "130px" }}
                                        onChange={this.handleChange}
                                    >
                                        <option value="code">원아코드</option>
                                        <option value="name">원아명</option>
                                        <option value="parent_id">부모계정</option>
                                        <option value="n_name">원명</option>
                                        <option value="c_name">반명</option>
                                    </select>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="keyword"
                                        value={this.state.keyword}
                                        onChange={this.handleChange}
                                        placeholder="키워드 입력"
                                        style={{ minWidth: "200px" }}
                                    />
                                    <div className="input-group-append">
                                        <button type="button" className="btn btn-primary btn btn-primary" onClick={() => this.getList(0)} disabled={this.state.doSomething}>
                                            검색
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-balham" style={{ height: this.state.paging ? "440px" : "540px" }}>
                                <AgGridReact
                                    onGridReady={this.onGridReady}
                                    defaultColDef={this.defaultColDef}
                                    columnDefs={this.listColumn}
                                    rowData={this.state.list}
                                    enableCellTextSelection={true}
                                    rowHeight={40}
                                />
                            </div>
                        </div>
                        {this.state.paging && (
                            <div className="row" style={{ marginTop: "10px" }}>
                                <div className="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
                                    <PaginationV2
                                        perPage={basePagingInfo.perPage}
                                        maxShowPage={basePagingInfo.maxShowPage}
                                        currentPage={Number(this.state.page)}
                                        total={this.state.total_cnt}
                                        callback={this.getList}
                                        disabled={this.state.doSomething}
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3"></div>
                            </div>
                        )}
                    </div>
                </div>
            );
        } else {
            return (
                <div className="card border-top">
                    <div className="card-body" style={{ height: this.props.height + "px", textAlign: "center", padding: "50px" }}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </div>
            );
        }
    }
}

export default List;
